<template>
    <CollapsedDropdown
        v-if="collapsed"
        icon="briefcase"
        :title="currentDepartmentName ? `Department: ${currentDepartmentName}` : 'Department'"
    >
        <template #default="{ close }">
            <a
                v-for="department in filteredDepartments"
                :key="department.id"
                class="cd-item"
                :class="{ active: department.id === selectedDepartment }"
                href="#"
                @click.prevent="
                    selectAndApply(department.id);
                    close();
                "
            >
                {{ department.name }}
            </a>
        </template>
    </CollapsedDropdown>
    <div
        v-else
        :class="{
            'sidebar-context-select': useCustomDropdown,
            'page-header-select': inlineLabel
        }"
    >
        <i
            v-if="inlineLabel"
            :class="['fas', `fa-${inlineIcon}`, 'page-header-select__icon']"
            aria-hidden="true"
        ></i>
        <select
            :id="selectId"
            v-model="selectedDepartment"
            class="form-select"
            :class="{
                customdropdown: useCustomDropdown,
                'page-header-select__input': inlineLabel
            }"
            :aria-label="inlineLabel ? `${inlineLabel} department` : 'Department Select'"
            @change="setDepartmentID"
        >
            <option value="" disabled>Select Department</option>
            <option
                v-for="Department in filteredDepartments"
                :key="Department.id"
                :value="Department.id"
            >
                {{ Department.name }}
            </option>
        </select>
        <label v-if="useCustomDropdown" :for="selectId" class="sidebar-switcher-label">
            Department
        </label>
    </div>
</template>

<script>
import { useId } from "vue";
import { useScopeChoices } from "@/composables/useScopeChoices";
import CollapsedDropdown from "./common/CollapsedDropdown.vue";

export default {
    components: { CollapsedDropdown },
    props: {
        useCustomDropdown: {
            type: Boolean,
            default: true // Default value to apply customdropdown class
        },
        collapsed: {
            type: Boolean,
            default: false
        },
        /**
         * Inline mode for use outside the sidebar (top bar, page headers):
         * icon + `page-header-select` styling, matching LocationSwitcher so the
         * context switchers read as one set of controls.
         */
        inlineLabel: {
            type: String,
            default: ""
        },
        inlineIcon: {
            type: String,
            default: "sitemap"
        }
    },
    setup() {
        return { selectId: useId(), ...useScopeChoices() };
    },
    data() {
        return {
            selectedDepartment:
                this.$store.state.departmentID || localStorage.getItem("department_id") || ""
        };
    },
    computed: {
        filteredDepartments() {
            return this.departmentChoices;
        },
        currentDepartmentName() {
            const current = this.filteredDepartments?.find((d) => d.id === this.selectedDepartment);
            return current ? current.name : "";
        }
    },
    watch: {
        "$store.state.departmentID"() {
            this.selectedDepartment = this.$store.state.departmentID;
        }
    },
    methods: {
        setDepartmentID() {
            this.$store.commit("setDepartmentByID", this.selectedDepartment);
            this.$toast.success(
                `Changed Department to ${
                    this.getByID(this.departmentChoices, this.selectedDepartment).name
                }`
            );
        },
        selectAndApply(id) {
            this.selectedDepartment = id;
            this.setDepartmentID();
        },
        getByID(array, id) {
            return array.find((item) => item.id == id);
        }
    }
};
</script>

<style scoped>
select.customdropdown {
    color: var(--side-nav-control-text, white);
    background-color: var(--side-nav-control-bg, #1a1a1a);
    border-radius: var(--forkto-radius-control);
    border: 1px solid var(--side-nav-control-border, transparent);
}
select.customdropdown {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: var(--side-nav-select-indicator);
    background-size: 0.75rem;
    background-repeat: no-repeat;
    background-position-x: 90%;
    background-position-y: center;
}

.sidebar-switcher-label {
    color: var(--side-nav-muted, rgba(255, 255, 255, 0.7));
}

.collapsed-switcher-btn {
    background-color: #1a1a1a;
    color: white;
    border: none;
    padding: 0.5rem 0;
}

.collapsed-switcher-btn:hover,
.collapsed-switcher-btn:focus {
    background-color: #2a2a2a;
    color: white;
}
</style>
